// const { baseURL } = require('@/config')
import request from '@/utils/request'
// import qs from 'qs'

/**
 *  查询【主页】推荐服务、学生办事、教师办事、访客办事列表
 * @param {*} data 
 * @returns 
 */
export function queryService(data) {
  return request({
    url: '/api/wtbuService/queryService',
    data,
    head: 'application/json;charset=UTF-8',
    method: 'post',
  })
}

/**
 * 查询【更多】页 服务部门
 * @returns 
 */
export function queryServiceTabList(){
  return request({
    url:'/api/wtbuService/queryServiceTabList',
    head: 'application/json;charset=UTF-8',
    method: 'get',
  })
}

/**
 * 查询【更多】页 服务类型
 * @param {*} dictTypeCode 
 * @returns 
 */
export function getDictByTypeCode(dictTypeCode){
  return request({
    url:'/api/base/dict/findDictByTypeCode?dictTypeCode='+dictTypeCode,
    head: 'application/json;charset=UTF-8',
    method: 'get',
  })
}

/**
 *  模糊查询
 * @param {*} searchData 
 * @returns 
 */
export function queryServiceName(searchData){
  return request({
    url:'/api/wtbuService/queryServiceName?searchData='+searchData+'&type=0',
    head: 'application/json;charset=UTF-8',
    method: 'get',
  })
}